import { render } from "./ShowLetterAvatar.vue?vue&type=template&id=1da9833c&scoped=true"
import script from "./ShowLetterAvatar.vue?vue&type=script&lang=js"
export * from "./ShowLetterAvatar.vue?vue&type=script&lang=js"

import "./ShowLetterAvatar.vue?vue&type=style&index=0&id=1da9833c&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da9833c"]])

export default __exports__